'use client'

import classes from './wrapper.module.css'

import { type PropsWithChildren } from 'react'

import { Flex, Stack, useMantineColorScheme } from '@mantine/core'

import ShalionLogo from '@/components/common/shalion-logo'

const Wrapper = (props: PropsWithChildren) => {
  const { children } = props
  const { colorScheme } = useMantineColorScheme()

  const backgroundImage =
    colorScheme === 'dark'
      ? '/assets/svg/auth-background-dark.svg'
      : '/assets/svg/auth-background-light.svg'

  return (
    <Flex
      className={classes.container}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Stack className={classes.wrapper}>
        <ShalionLogo colorScheme={colorScheme} />
        {children}
      </Stack>
    </Flex>
  )
}

export default Wrapper
